import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconPrefix, library } from "@fortawesome/fontawesome-svg-core";
import {
  faEnvelope,
  faHelmetSafety,
  faCalendar,
  faNavicon,
  faWarning,
  faUsers,
  faHome,
  faImage,
  faGear,
  faGlobe,
  faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faSnapchat,
  faYoutube,
  faSpotify,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faEnvelope,
  faHelmetSafety,
  faCalendar,
  faInstagram,
  faTiktok,
  faGear,
  faImage,
  faGlobe,
  faNavicon,
  faUsers,
  faHome,
  faSnapchat,
  faYoutube,
  faSpotify,
  faChevronLeft,
  faWarning
);

export type IconType = {
  className?: any;
  prefix?: IconPrefix;
  href?: string;
  icon:
    | "envelope"
    | "home"
    | "helmet-safety"
    | "calendar"
    | "image"
    | "instagram"
    | "chevron-left"
    | "navicon"
    | "warning"
    | "youtube"
    | "spotify"
    | "gear"
    | "globe"
    | "users"
    | "snapchat"
    | "tiktok";
};

function Icon({ className, href, prefix = "fas", icon }: IconType) {
  if (href)
    return (
      <a href={href} target="_blank" rel="noreferrer">
        <FontAwesomeIcon className={className} icon={[prefix, icon]} />
      </a>
    );
  return <FontAwesomeIcon className={className} icon={[prefix, icon]} />;
}

export default Icon;
